export default "__VITE_ASSET__83mH5Kex__"